import React from 'react';
import LCVTutorDialog from './LCVTutorDialog';

const PHASE_LABELS = {
  tutorial: 'Tutorial',
  frontloading: 'Introduction',
  learning: 'I Do — Learning',
  workbook_ready: 'We Do — Workbook',
  workbook_exercise: 'We Do — Workbook',
  workbook_options: 'We Do — Review',
  knowledge_check: 'You Do — Check',
  knowledge_check_summary: 'Check Summary',
  mastery: 'Mastery Test',
  results: 'Results',
};

const LCVTutorPanel = ({
  text,
  phase,
  animationProgress,
  paused = false,
  canPause = false,
  canSkip = false,
  fontSize,
  onFontSizeChange,
  onPause,
  onResume,
  onSkip,
}) => {
  if (!text) return null;

  return (
    <LCVTutorDialog
      className="lcv-tutor-panel"
      text={text}
      label={PHASE_LABELS[phase] || ''}
      animated
      progressRatio={animationProgress}
      showControls
      paused={paused}
      canPause={canPause}
      canSkip={canSkip}
      fontSize={fontSize}
      onFontSizeChange={onFontSizeChange}
      onPause={onPause}
      onResume={onResume}
      onSkip={onSkip}
    />
  );
};

export default LCVTutorPanel;
